import { type DocumentImage } from '~/gql/graphql'

import { safeParseJson } from '../../generals'
import { type FigureMeta } from '../figureInfo'

import { getMetaValue } from './internal/getMetaValue'

type CreateFigureMetaFromDocumentImageParams = {
  documentImage: App.PickGraphQL<DocumentImage, 'allMetadata'>
  currentUserEmail: string | undefined
}

/**
 * DocumentImage から FigureMeta を作成します。
 *
 * @param params - パラメータ。
 * @returns 作成された FigureMeta。
 */
export function createFigureMeta(
  params: CreateFigureMetaFromDocumentImageParams,
): FigureMeta {
  const { currentUserEmail, documentImage } = params
  const creatorRaw = getMetaValue(documentImage, 'creator')
  // 新データは JSON.stringify されているのでパースする
  const creator = safeParseJson(creatorRaw) ?? creatorRaw
  const isOwner = creator === currentUserEmail

  return { isArchivable: isOwner, isDeletable: isOwner, isUnarchivable: true }
}
